const BaseTitle = ({ title }) => {
  return <h1 className="text-4xl text-center antialiased py-4">{title}</h1>;
};

export default BaseTitle;
